<!-- ── Hero ── -->
<section class="hero">
  <div class="hero-inner">
    <div class="hero-left">
      <h1>Requests<span *ngIf="projectName" class="hero-project"> — {{ projectName }}</span></h1>
      <p class="hero-sub">Select a project to view and manage requests</p>
    </div>
    <div class="hero-right">
      <div class="hero-kpi" *ngIf="requests.length > 0">
        <mat-icon>question_answer</mat-icon>
        <div class="kpi-text">
          <span class="kpi-value">{{ requests.length }}</span>
          <span class="kpi-label">Shown</span>
        </div>
      </div>
      <div class="hero-kpi accent" *ngIf="allRequests.length > 0">
        <mat-icon>folder_open</mat-icon>
        <div class="kpi-text">
          <span class="kpi-value">{{ allRequests.length }}</span>
          <span class="kpi-label">Total</span>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="page-shell" (window:keydown.escape)="closeModal()">

  <!-- Project Selector Card -->
  <div class="card selector-card selector-card-inline">
    <div class="selector-card-header">
      <mat-icon>folder_open</mat-icon>
      <h3>Select Project</h3>
    </div>
    <div class="selector-body selector-body-inline">
      <div class="select-wrap">
        <mat-icon class="select-icon">business</mat-icon>
        <select
          id="project-select"
          [(ngModel)]="projectNumber"
          (ngModelChange)="onProjectSelectionChange($event)">
          <option [ngValue]="null">All Projects</option>
          <option *ngFor="let project of projects" [ngValue]="project.projectNumber">
            {{ project.projectNumber }} — {{ project.projectName }}
          </option>
        </select>
      </div>
      <div *ngIf="projectsLoading" class="inline-loading">
        <mat-icon class="spinner-sm">hourglass_empty</mat-icon> Loading projects…
      </div>
    </div>
  </div>


  <div class="filter-options">
  <div class="checkbox-group">
    <label class="checkbox-container">
      <input type="checkbox" [(ngModel)]="filters.iq" (change)="applyFilters()">
      <span class="checkbox-label">IQ</span>
    </label>
    
    <label class="checkbox-container">
      <input type="checkbox" [(ngModel)]="filters.rfi" (change)="applyFilters()">
      <span class="checkbox-label">RFI</span>
    </label>
    
    <label class="checkbox-container">
      <input type="checkbox" [(ngModel)]="filters.crfi" (change)="applyFilters()">
      <span class="checkbox-label">CRFI</span>
    </label>
    
    <label class="checkbox-container">
      <input type="checkbox" [(ngModel)]="filters.cdq" (change)="applyFilters()">
      <span class="checkbox-label">CDQ</span>
    </label>

    <label class="checkbox-container">
      <input type="checkbox" [(ngModel)]="filters.risk" (change)="applyFilters()">
      <span class="checkbox-label">RISKS</span>
    </label>
  </div>
</div>

  <div class="request-tools">
    <div class="search-panel">
      <div class="search-panel-main">
        <div class="search-input-wrap">
          <mat-icon class="search-input-icon">search</mat-icon>
          <input
            type="text"
            class="search-input"
            placeholder="Search request #, description, status, revisions, responses, and file names"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
          >
        </div>

        <button
          type="button"
          class="advanced-toggle-btn"
          (click)="toggleAdvancedFilters()"
          [attr.aria-label]="showAdvancedFilters ? 'Hide advanced filters' : 'Show advanced filters'"
          [title]="showAdvancedFilters ? 'Hide advanced filters' : 'Show advanced filters'">
          <mat-icon>{{ showAdvancedFilters ? 'expand_less' : 'tune' }}</mat-icon>
          <span class="advanced-toggle-count" *ngIf="hasActiveAdvancedFilters()">{{ getActiveAdvancedFilterCount() - (searchQuery.trim() ? 1 : 0) }}</span>
        </button>

        <button
          type="button"
          class="refresh-btn"
          (click)="fetchRequests()"
          title="Refresh requests">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <div class="search-panel-meta">
        <span>{{ getFilterSummary() }}</span>
        <span *ngIf="metadataIndexedCount < metadataTotalCount">Indexing revisions and attachments {{ metadataIndexedCount }}/{{ metadataTotalCount }}</span>
      </div>
      <div class="advanced-filters-panel advanced-filters-panel-integrated" *ngIf="showAdvancedFilters">
        <div class="advanced-filters-header">
          <h3>Advanced Filters</h3>
          <button type="button" class="filter-reset-btn" (click)="clearAdvancedFilters()" [disabled]="getActiveAdvancedFilterCount() === 0">Clear Filters</button>
        </div>

        <div class="advanced-filters-grid">
          <label class="filter-field">
            <span>Status</span>
            <select [(ngModel)]="filters.status" (ngModelChange)="onAdvancedFiltersChange()">
              <option value="all">All</option>
              <option value="Open">Open</option>
              <option value="Answered">Answered</option>
              <option value="Closed">Closed</option>
            </select>
          </label>

          <label class="filter-field">
            <span>Stage</span>
            <select [(ngModel)]="filters.stage" (ngModelChange)="onAdvancedFiltersChange()">
              <option value="all">All</option>
              <option value="Action Required">Action Required</option>
              <option value="Acknowledged">Acknowledged</option>
              <option value="In Progress">In Progress</option>
              <option value="Complete">Complete</option>
            </select>
          </label>

          <label class="filter-field">
            <span>Type</span>
            <select [(ngModel)]="filters.requestType" (ngModelChange)="onAdvancedFiltersChange()">
              <option value="all">All types</option>
              <option *ngFor="let type of getAvailableRequestTypes()" [value]="type">{{ type }}</option>
            </select>
          </label>

          <label class="filter-field">
            <span>Date From</span>
            <input type="date" [(ngModel)]="filters.dateFrom" (ngModelChange)="onAdvancedFiltersChange()">
          </label>

          <label class="filter-field">
            <span>Date To</span>
            <input type="date" [(ngModel)]="filters.dateTo" (ngModelChange)="onAdvancedFiltersChange()">
          </label>
        </div>

        <div class="advanced-toggle-row">
          <label class="toggle-chip">
            <input type="checkbox" [(ngModel)]="filters.hasAttachments" (change)="onAdvancedFiltersChange()">
            <span>Has attachments</span>
          </label>
          <label class="toggle-chip">
            <input type="checkbox" [(ngModel)]="filters.awaitingResponse" (change)="onAdvancedFiltersChange()">
            <span>Awaiting response</span>
          </label>
        </div>
      </div>
    </div>
  </div>

    <!-- Success message alert that appears conditionally -->
    <div *ngIf="updateSuccess" class="success-message">
      <mat-icon>check_circle</mat-icon>
      {{ updateSuccessMessage }}
    </div>

    <div *ngIf="emailActionMessage" class="email-action-message" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ emailActionMessage }}</span>
      <button type="button" aria-label="Dismiss message" (click)="emailActionMessage = null">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  
  <!-- <button (click)="fetchRequests()" [disabled]="projectsLoading">Get Requests</button> -->
  
    <div *ngIf="loading">Loading...</div>
    <div *ngIf="error" class="error">{{ error }}</div>
  
    <div *ngIf="requests.length > 0">
      <div
        class="cards-header"
        [ngClass]="{
          'with-project': projectNumber === null,
          'with-email': canEmailRequests()
        }"
      >
        <div class="col project sortable" *ngIf="projectNumber === null" (click)="sortBy('project')">
          Project <span class="sort-arrow">{{ getProjectSortLabel() }}</span>
        </div>
        <div class="col number sortable" (click)="sortBy('number')">
          Request <span class="sort-arrow">{{ sortColumn === 'number' ? (sortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span>
        </div>
        <div class="col description">Description</div>
        <div class="col status sortable" (click)="sortBy('status')">
          Status <span class="sort-arrow">{{ statusSortStep === 1 ? 'OP' : statusSortStep === 2 ? 'AN' : statusSortStep === 3 ? 'CL' : '⇅' }}</span>
        </div>
        <div class="col stage sortable" (click)="sortBy('stage')">
          Stage <span class="sort-arrow">{{ stageSortStep === 1 ? 'AR' : stageSortStep === 2 ? 'AK' : stageSortStep === 3 ? 'IP' : stageSortStep === 4 ? 'CP' : '⇅' }}</span>
        </div>
        <div class="col priority sortable" (click)="sortBy('priority')">
          Priority <span class="sort-arrow">{{ prioritySortStep === 1 ? 'HI' : prioritySortStep === 2 ? 'MD' : prioritySortStep === 3 ? 'LO' : '⇅' }}</span>
        </div>
        <div class="col date sortable" (click)="sortBy('date')">
          Date Created <span class="sort-arrow">{{ sortColumn === 'date' ? (sortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span>
        </div>
        <div class="col revisions sortable" (click)="sortBy('revisions')">
          Revisions <span class="sort-arrow">{{ sortColumn === 'revisions' ? (sortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span>
        </div>
        <div class="col uploads" *ngIf="canEmailRequests()">Uploads</div>
        <div class="col files sortable" (click)="sortBy('files')">
          Files <span class="sort-arrow">{{ sortColumn === 'files' ? (sortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span>
        </div>
      </div>

      <div class="request-cards">
        <div class="card" *ngFor="let r of requests" (click)="toggleRequestCard(r, cardEl)" #cardEl tabindex="0"
             [id]="'request-card-' + r.requestGuid"
             [class.highlighted]="expandedRequests[r.requestGuid]">
          <div
            class="card-header"
            [ngClass]="{
              'with-project': projectNumber === null,
              'with-email': canEmailRequests()
            }"
          >
            <div class="col project" *ngIf="projectNumber === null">
              <span class="project-badge clickable" [style.background]="getProjectColor(r.projectNumber)" [style.color]="getProjectTextColor(r.projectNumber)" (click)="$event.stopPropagation(); filterByProject(r.projectNumber)" title="Click to filter by project {{ r.projectNumber }}">{{ r.projectNumber }}</span>
            </div>
            <div class="col number">{{ r.requestType }}-{{ r.number }}</div>
            <div class="col description" [innerHTML]="r.description"></div>
            <div class="col status">
              <ng-container *ngIf="canEditRfiStatus(); else statusViewSmall">
                <select (click)="$event.stopPropagation()" (change)="$event.stopPropagation(); updateStatus(r)" [(ngModel)]="r.status" class="status-select small" [ngClass]="getStatusClass(r.status)">
                  <option>Open</option>
                  <option>Answered</option>
                  <option>Closed</option>
                </select>
              </ng-container>
              <ng-template #statusViewSmall>
                <div class="status-badge" [ngClass]="{ 'status-open': r.status==='Open', 'status-answered': r.status==='Answered', 'status-closed': r.status==='Closed' }">{{ r.status }}</div>
              </ng-template>
            </div>
            <div class="col stage">
              <ng-container *ngIf="r.status !== 'Closed'">
                <ng-container *ngIf="r.status === 'Answered' && canEditRfiStage(); else stageView">
                  <select (click)="$event.stopPropagation()" (change)="$event.stopPropagation(); updateStage(r, $any($event.target).value)" [ngModel]="getStageDisplay(r.stage)" class="stage-select small" [ngClass]="getStageClass(r.stage)">
                    <option>Action Required</option>
                    <option>Acknowledged</option>
                    <option>In Progress</option>
                    <option>Complete</option>
                  </select>
                </ng-container>
                <ng-template #stageView>
                  <div *ngIf="r.status === 'Answered'" class="stage-badge" [ngClass]="getStageClass(r.stage)">{{ getStageDisplay(r.stage) }}</div>
                </ng-template>
              </ng-container>
            </div>
            <div class="col priority">
              <ng-container *ngIf="r.status !== 'Closed'">
                <ng-container *ngIf="canEditRfiPriority(); else priorityView">
                  <select (click)="$event.stopPropagation()" (change)="$event.stopPropagation(); updatePriority(r)" [(ngModel)]="r.priority" class="priority-select small" [ngClass]="getPriorityClass(r.priority)">
                    <option>High</option>
                    <option>Medium</option>
                    <option>Low</option>
                  </select>
                </ng-container>
                <ng-template #priorityView>
                  <div class="priority-badge" [ngClass]="getPriorityClass(r.priority)">{{ r.priority }}</div>
                </ng-template>
              </ng-container>
            </div>
            <div class="col date">{{ r.createdDate | date: 'dd/MMM/yyyy' }}</div>
            <div class="col revisions">{{ revisionCountMap[r.requestGuid] != null ? revisionCountMap[r.requestGuid] : '—' }}</div>
            <div class="col uploads" *ngIf="canEmailRequests()">
              <button
                *ngIf="isOpenRequest(r)"
                type="button"
                class="request-email-button"
                title="Email request upload"
                [attr.aria-label]="'Email files for ' + r.requestType + ' ' + r.number"
                (click)="$event.stopPropagation(); openRequestEmailModal(r)"
              >
                <mat-icon>email</mat-icon>
              </button>
            </div>
            <div class="col files">
              <mat-icon *ngIf="hasFilesMap[r.requestGuid]" class="files-clip-icon" (click)="$event.stopPropagation(); showFilesForRequest(r, cardEl)" title="View files">attach_file</mat-icon>
              <span class="caret" (click)="$event.stopPropagation(); toggleRequestCard(r, cardEl)">{{ expandedRequests[r.requestGuid] ? '▾' : '▸' }}</span>
            </div>
          </div>

          <div class="card-body" *ngIf="expandedRequests[r.requestGuid]">

            <div class="request-detail-bar" *ngIf="r.area || r.sequence">
              <div class="detail-item" *ngIf="r.area">
                <span class="detail-label">Area</span>
                <span class="detail-value">{{ r.area }}</span>
              </div>
              <div class="detail-item" *ngIf="r.sequence">
                <span class="detail-label">Sequence</span>
                <span class="detail-value">{{ r.sequence }}</span>
              </div>
            </div>

            <div *ngIf="loadingRevisions[r.requestGuid]">Loading revisions...</div>
            <div *ngIf="!loadingRevisions[r.requestGuid] && revisionsMap[r.requestGuid]?.length === 0">No revisions found.</div>

            <div class="revision-card" *ngFor="let rev of revisionsMap[r.requestGuid]; let ri = index" (click)="$event.stopPropagation()">
              <!-- REVISION HEADER -->
              <div class="revision-card-header" (click)="$event.stopPropagation(); toggleRevision(rev, r.requestGuid)" style="cursor: pointer;">
                <div class="revision-card-header-left">
                  <span class="revision-label">REVISION {{ rev.revisionNumber ?? (ri + 1) }}</span>
                  <span class="revision-meta-info">{{ rev.dateCreated | date: 'dd/MMM/yyyy HH:mm' }} &mdash; {{ userCache.get(rev.createdBy) || 'Unknown' }}</span>
                </div>
                <div class="revision-card-header-right">
                  <div class="rev-badge" [ngClass]="{ 'answered': (rev.responses && rev.responses.length > 0), 'awaiting': !(rev.responses && rev.responses.length > 0) }">
                    <ng-container *ngIf="rev.responses && rev.responses.length > 0">{{ rev.responses.length }} response{{ rev.responses.length > 1 ? 's' : '' }}</ng-container>
                    <ng-container *ngIf="!(rev.responses && rev.responses.length > 0)">Awaiting</ng-container>
                  </div>
                  <span class="rev-toggle-icon">{{ revisionExpanded[rev.revisionGuid] ? '▾' : '▸' }}</span>
                </div>
              </div>

              <!-- REVISION BODY (question text) -->
              <div class="revision-card-body" (click)="openRevisionModal(rev); $event.stopPropagation()" tabindex="0" role="button" style="cursor: pointer;">
                <div class="revision-text" [innerHTML]="rev.questionText"></div>

                <!-- Revision attached files -->
                <div class="inline-files" *ngIf="revisionExpanded[rev.revisionGuid]">
                  <div *ngIf="revisionFilesLoading[rev.revisionGuid]" class="inline-files-loading">Loading files...</div>
                  <div *ngIf="revisionFilesMap[rev.revisionGuid] && revisionFilesMap[rev.revisionGuid].length > 0" class="inline-files-list">
                    <span class="inline-files-label"><mat-icon class="inline-files-mat-icon">attach_file</mat-icon> Attachments</span>
                    <a *ngFor="let f of revisionFilesMap[rev.revisionGuid]" href="" class="inline-file-link" (click)="openFile(f, $event)">
                      <mat-icon class="inline-file-kind-icon">{{ getFileTypeIcon(f.fileName) }}</mat-icon>
                      {{ getDisplayFileName(f.fileName) }}
                    </a>
                  </div>
                </div>
              </div>

              <!-- EXPANDED: RESPONSES -->
              <div *ngIf="revisionLoadingMap[rev.revisionGuid]" class="responses-loading">Loading responses...</div>

              <div class="responses-section" *ngIf="revisionExpanded[rev.revisionGuid]">
                <div class="responses-section-title" *ngIf="rev.responses && rev.responses.length > 0">
                  <span class="responses-label">RESPONSES</span>
                </div>
                <div *ngIf="!rev.responses || rev.responses.length === 0" class="no-responses">No responses yet.</div>
                <div *ngFor="let resp of rev.responses" class="response-card" (click)="openResponseModal(resp); $event.stopPropagation()" tabindex="0" role="button">
                  <div class="response-card-header">
                    <span class="response-label">Response</span>
                    <span class="response-meta-info">{{ resp.dateCreated | date: 'dd/MMM/yyyy HH:mm' }} &mdash; {{ userCache.get(resp.responder) || 'Unknown' }}</span>
                  </div>
                  <div class="response-card-text" [innerHTML]="resp.responseText"></div>

                  <!-- Response attached files -->
                  <div class="inline-files" *ngIf="responseFilesMap[resp.responseGuid] && responseFilesMap[resp.responseGuid].length > 0">
                    <div class="inline-files-list">
                      <span class="inline-files-label"><mat-icon class="inline-files-mat-icon">attach_file</mat-icon> Attachments</span>
                      <a *ngFor="let f of responseFilesMap[resp.responseGuid]" href="" class="inline-file-link" (click)="openFile(f, $event)">
                        <mat-icon class="inline-file-kind-icon">{{ getFileTypeIcon(f.fileName) }}</mat-icon>
                        {{ getDisplayFileName(f.fileName) }}
                      </a>
                    </div>
                  </div>
                  <div *ngIf="responseFilesLoading[resp.responseGuid]" class="inline-files-loading">Loading files...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- Files are now displayed in a modal; bottom panel removed -->
  <!-- Response modal -->
  <div class="response-modal-overlay" *ngIf="selectedResponse" (click)="closeModal()">
    <div class="response-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <div class="rm-header">
        <div class="rm-header-left">
          <span class="rm-badge">Response {{ selectedResponse.responseNumber }}</span>
          <span class="rm-responder">{{ userCache.get(selectedResponse.responder) || 'Unknown' }}</span>
        </div>
        <button class="rm-close" (click)="closeModal()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="rm-date">{{ selectedResponse.dateCreated | date:'dd MMM yyyy, h:mm a' }}</div>
      <div class="rm-divider"></div>
      <div class="rm-body" [innerHTML]="selectedResponse.responseText"></div>
      <div class="rm-attachments" *ngIf="selectedResponse.files && selectedResponse.files.length > 0">
        <div class="rm-divider"></div>
        <div class="rm-attachments-label">
          <mat-icon class="rm-attach-icon">attach_file</mat-icon>
          Attachments ({{ selectedResponse.files.length }})
        </div>
        <div class="rm-files-list">
          <a *ngFor="let f of selectedResponse.files" href="" class="rm-file-link" (click)="openFile(f, $event)">
            <mat-icon class="rm-file-icon">{{ getFileTypeIcon(f.fileName) }}</mat-icon>
            <span>{{ f.displayName || getDisplayFileName(f.fileName) }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Revision modal -->
  <div class="response-modal-overlay" *ngIf="selectedRevision" (click)="closeRevisionModal()">
    <div class="response-modal revision-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <div class="rm-header">
        <div class="rm-header-left">
          <span class="rm-badge revision-badge">Revision {{ selectedRevision.revisionNumber }}</span>
          <span class="rm-responder">{{ userCache.get(selectedRevision.createdBy) || 'Unknown' }}</span>
        </div>
        <button class="rm-close" (click)="closeRevisionModal()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="rm-date">{{ selectedRevision.dateCreated | date:'dd MMM yyyy, h:mm a' }}</div>
      <div class="rm-divider"></div>
      <div class="rm-body" [innerHTML]="selectedRevision.questionText"></div>
      <div class="rm-attachments" *ngIf="revisionFilesMap[selectedRevision.revisionGuid] && revisionFilesMap[selectedRevision.revisionGuid].length > 0">
        <div class="rm-divider"></div>
        <div class="rm-attachments-label">
          <mat-icon class="rm-attach-icon">attach_file</mat-icon>
          Attachments ({{ revisionFilesMap[selectedRevision.revisionGuid].length }})
        </div>
        <div class="rm-files-list">
          <a *ngFor="let f of revisionFilesMap[selectedRevision.revisionGuid]" href="" class="rm-file-link" (click)="openFile(f, $event)">
            <mat-icon class="rm-file-icon">{{ getFileTypeIcon(f.fileName) }}</mat-icon>
            <span>{{ getDisplayFileName(f.fileName) }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Files modal -->
  <div class="files-modal-overlay" *ngIf="showFilesModal" (click)="closeFilesModal()">
    <div class="files-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">

      <!-- Modal top bar -->
      <div class="fm-topbar">
        <div class="fm-topbar-title">
          <h2>Request #{{ selectedRequestNumber }}</h2>
          <span class="fm-topbar-desc" *ngIf="selectedRequestDescription" [innerHTML]="selectedRequestDescription"></span>
        </div>
        <button class="fm-close-btn" (click)="closeFilesModal()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Scrollable body -->
      <div class="fm-body">

        <!-- ===== REQUEST FILES TABLE ===== -->
        <section class="fm-section">
          <div class="fm-section-header">
            <h3>Request Files</h3>
            <div class="fm-sort-control">
              <label for="fm-sort">Sort:</label>
              <select id="fm-sort" [(ngModel)]="fileSortOrder" (ngModelChange)="setFileSortOrder($event)">
                <option value="asc">Oldest First</option>
                <option value="desc">Most Recent</option>
              </select>
            </div>
          </div>
          <div *ngIf="selectedFiles.length > 0" class="fm-table-wrap">
            <table class="fm-table">
              <thead>
                <tr>
                  <th>File</th>
                  <th>Source</th>
                  <th>Created By</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of selectedFiles">
                  <td>
                    <a href="" (click)="openFile(file, $event)">{{ file.displayName || file.fileName }}</a>
                    <div class="fm-file-meta-row">
                      <mat-icon class="inline-file-kind-icon">{{ getFileTypeIcon(file.fileName) }}</mat-icon>
                    </div>
                  </td>
                  <td>{{ file.source }}</td>
                  <td>{{ userCache.get(file.uploadedBy) || 'Unknown' }}</td>
                  <td>{{ file.createdDate | date: 'dd/MMM/yyyy' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="selectedFiles.length === 0" class="fm-empty">No files attached to this request.</div>
        </section>

        <!-- ===== REVISIONS + RESPONSES ===== -->
        <div *ngFor="let rev of modalRevisions; let ri = index" class="fm-revision-block">
          <!-- Revision header bar -->
          <div class="fm-rev-header" (click)="toggleModalRevision(rev.revisionGuid)">
            <div class="fm-rev-header-left">
              <span class="fm-rev-number">Revision {{ rev.revisionNumber ?? (ri + 1) }}</span>
            </div>
            <div class="fm-rev-header-right">
              <span class="fm-rev-date">{{ rev.dateCreated | date: 'dd/MMM/yyyy' }}</span>
              <span class="fm-rev-toggle">{{ modalRevisionExpanded[rev.revisionGuid] ? '▾' : '▸' }}</span>
            </div>
          </div>

          <!-- Revision body (always show summary, details on expand) -->
          <div class="fm-rev-body">
            <div class="fm-rev-meta">Created by: {{ userCache.get(rev.createdBy) || 'Unknown' }}</div>

            <!-- Revision question text (if any) -->
            <div class="fm-rev-question" *ngIf="rev.questionText" [innerHTML]="rev.questionText"></div>

            <!-- Revision attachments -->
            <div class="fm-attachments" *ngIf="rev.files && rev.files.length > 0">
              <div class="fm-attachments-label">ATTACHMENTS</div>
              <div *ngFor="let f of rev.files" class="fm-attachment-item">
                <mat-icon class="fm-attachment-icon">{{ getFileTypeIcon(f.fileName) }}</mat-icon>
                <a href="" (click)="openFile(f, $event)">{{ f.displayName || f.fileName }}</a>
              </div>
            </div>
            <div class="fm-no-attachments" *ngIf="!rev.files || rev.files.length === 0">No attachments</div>

            <!-- Responses section (expanded) -->
            <div class="fm-responses-area" *ngIf="modalRevisionExpanded[rev.revisionGuid]">
              <div class="fm-responses-divider" *ngIf="rev.responses && rev.responses.length > 0">
                <span class="fm-responses-divider-label">RESPONSES</span>
              </div>
              <div *ngIf="!rev.responses || rev.responses.length === 0" class="fm-empty-sm">No responses.</div>

              <div *ngFor="let resp of rev.responses" class="fm-response-card">
                <div class="fm-response-header">
                  <span class="fm-response-title">Response {{ resp.responseNumber }} &mdash; {{ userCache.get(resp.responder) || 'Unknown' }}</span>
                  <span class="fm-response-date">{{ resp.dateCreated | date: 'dd/MMM/yyyy' }}</span>
                </div>
                <div class="fm-response-text" *ngIf="resp.responseText" [innerHTML]="resp.responseText"></div>
                <!-- Response attachments -->
                <div class="fm-attachments" *ngIf="resp.files && resp.files.length > 0">
                  <div *ngFor="let f of resp.files" class="fm-attachment-item">
                    <mat-icon class="fm-attachment-icon">{{ getFileTypeIcon(f.fileName) }}</mat-icon>
                    <a href="" (click)="openFile(f, $event)">{{ f.displayName || f.fileName }}</a>
                  </div>
                </div>
                <div class="fm-no-attachments" *ngIf="!resp.files || resp.files.length === 0">No attachments</div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="modalRevisions.length === 0" class="fm-empty" style="margin-top: 20px;">No revisions for this request.</div>
      </div>

      <!-- Footer -->
      <div class="fm-footer">
        <button class="fm-close-footer-btn" (click)="closeFilesModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="pdf-preview-overlay" *ngIf="pdfPreviewOpen" (click)="closePdfPreview()">
    <div class="pdf-preview-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-label="PDF preview">
      <div class="pdf-preview-topbar">
        <div class="pdf-preview-heading">
          <h3>{{ pdfPreviewTitle || 'File Preview' }}</h3>
          <div class="pdf-preview-meta">
            <span *ngIf="pdfPreviewLoading">Loading preview...</span>
            <span *ngIf="!pdfPreviewLoading && previewFileType === 'pdf' && pdfPreviewPageCount !== null">{{ pdfPreviewPageCount }} page{{ pdfPreviewPageCount === 1 ? '' : 's' }}</span>
            <span *ngIf="!pdfPreviewLoading && previewFileType === 'image' && !pdfPreviewError">Image preview ready</span>
            <span *ngIf="!pdfPreviewLoading && previewFileType === 'pdf' && pdfPreviewPageCount === null && !pdfPreviewError">Preview ready</span>
          </div>
        </div>
        <div class="pdf-preview-actions">
          <button type="button" class="pdf-toolbar-btn" (click)="downloadCurrentPreviewFile()" [disabled]="fileActionInProgress || !pdfPreviewFileId">Download</button>
          <button type="button" class="pdf-toolbar-btn pdf-toolbar-btn-secondary" (click)="closePdfPreview()">Close</button>
        </div>
      </div>

      <div class="pdf-preview-body">
        <div *ngIf="pdfPreviewLoading" class="pdf-preview-state">Preparing PDF preview...</div>

        <div *ngIf="pdfPreviewError" class="pdf-preview-state pdf-preview-state-error">
          <p>{{ pdfPreviewError }}</p>
          <button type="button" class="pdf-toolbar-btn" (click)="downloadCurrentPreviewFile()" [disabled]="fileActionInProgress || !pdfPreviewFileId">Download File</button>
        </div>

        <ng-container *ngIf="!pdfPreviewLoading && !pdfPreviewError && pdfPreviewUrl">
          <img *ngIf="previewFileType === 'image'" class="image-preview-object" [src]="pdfPreviewUrl" [alt]="pdfPreviewTitle || 'Attachment preview'">
          <object *ngIf="previewFileType === 'pdf'" class="pdf-preview-object" [data]="pdfPreviewUrl" type="application/pdf" (error)="markPdfObjectLoadFailed()">
            <div class="pdf-preview-state pdf-preview-state-error">
              <p>This browser could not render the PDF preview. You can still download the file.</p>
              <button type="button" class="pdf-toolbar-btn" (click)="downloadCurrentPreviewFile()" [disabled]="fileActionInProgress || !pdfPreviewFileId">Download File</button>
            </div>
          </object>
          <div *ngIf="pdfObjectLoadFailed" class="pdf-preview-inline-note">Preview rendering failed. Download is still available.</div>
        </ng-container>

        <div *ngIf="fileActionError" class="pdf-preview-inline-note pdf-preview-inline-note-error">{{ fileActionError }}</div>
      </div>
    </div>
  </div>

  <app-request-email-modal
    *ngIf="activeEmailRequest && getCurrentUserEmail() as senderEmail"
    [request]="activeEmailRequest"
    [senderEmail]="senderEmail"
    (closed)="closeRequestEmailModal()"
    (sent)="handleRequestEmailSent($event)"
  ></app-request-email-modal>
</div>
  
